/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSectorCommand } from '../../models/update-sector-command';
import { UpdateSectorCommandResult } from '../../models/update-sector-command-result';

export interface ApiSectorUpdateSectorPatch$Plain$Params {
      body?: UpdateSectorCommand
}

export function apiSectorUpdateSectorPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiSectorUpdateSectorPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSectorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorUpdateSectorPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSectorCommandResult>;
    })
  );
}

apiSectorUpdateSectorPatch$Plain.PATH = '/api/Sector/UpdateSector';
